// extracted by mini-css-extract-plugin
export default {"message":"Message_message__fh13J","error":"Message_error__WMKav","cross":"Message_cross__Z1wLO"};